/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Send_CodeInputs */

const en_signin_send_code = /** @type {(inputs: Signin_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send sign-in code`)
};

const id_signin_send_code = /** @type {(inputs: Signin_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim kode masuk`)
};

/**
* | output |
* | --- |
* | "Send sign-in code" |
*
* @param {Signin_Send_CodeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_send_code = /** @type {((inputs?: Signin_Send_CodeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Send_CodeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_send_code(inputs)
	return en_signin_send_code(inputs)
});